class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document.querySelectorAll('#ProductGridContainer .scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');
    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    console.log("onSubmitHandler");

    /* ----------------------------------------------------------
      BIND HANDLER ONLY ONCE (GLOBAL)
    ---------------------------------------------------------- */
    if (!window.__filterTrackingBound) {
      window.__filterTrackingBound = true;
        
        try {
          if(event.target.closest(".list-menu__item facets__item")){
          let isReset = false;
          let resetURL = null;

          const resetLink = event.target.closest(".facets__reset");
          if (resetLink) {
            isReset = true;
            event.preventDefault();
            resetURL = resetLink.getAttribute("href");
          }

          let sectionName =
            document.querySelector(".collection-hero__title")?.innerText || "NA";
          sectionName = sectionName.replace(/\s+/g, " ").trim();

          const pageType = window.location.pathname.includes("/collections/")
            ? "collection_page"
            : window.location.pathname.includes("/products/")
            ? "product_page"
            : "home";

          const appliedValue =
            !isReset && activeFilters.length > 0
              ? activeFilters.join("|") + "|"
              : "NA";

          const ctaText = isReset ? "Reset" : "Apply";
          const linkPath = window.location.href || "NA";
          const userId = window.Shopify?.customer?.id || "NA";
          const userType = userId !== "NA" ? "logged_in" : "guest";

          const platform =
            /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
              ? "M-web"
              : "D-web";
          }


          setTimeout(() => {
          let activeFilters_VIL = [];
          let s_appliedValue = "NA";
          document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
              let groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML?.trim() || "Unknown Group";
              let labelText = input.value;
              activeFilters_VIL.push(`${groupLabel}-${labelText}`);
          });
          let sortSelect = document.querySelector(".facet-filters__sort");
          if (sortSelect) {
              let selectedSort = sortSelect.options[sortSelect.selectedIndex].innerHTML.trim();
              s_appliedValue = `${selectedSort}`;
          }
          let priceMin = document.querySelector("input[name='filter.v.price.gte']")?.value;
          let priceMax = document.querySelector("input[name='filter.v.price.lte']")?.value;
          if (priceMin || priceMax) {
              activeFilters_VIL.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
          }

          if(window.outerWidth <= 767){
            activeFilters_VIL = [];
            s_appliedValue = "NA";
            document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
              console.log("input>>>>>>>",input);
              let groupLabel = input.closest("details")?.querySelector("summary span")?.innerHTML?.trim() || "Unknown Group";
              let labelText = input.value;
              activeFilters_VIL.push(`${groupLabel}-${labelText}`);
            });
            let sortSelectM = document.querySelector(".mobile-facets__main .mobile-facets__sort select");
            if (sortSelectM) {
              let selectedSortM = sortSelectM.options[sortSelectM.selectedIndex].innerHTML.trim();
              s_appliedValue = `${selectedSortM}`;
            }
            let priceMin = document.querySelector(".mobile-facets__main input[name='filter.v.price.gte']")?.value;
            let priceMax = document.querySelector(".mobile-facets__main input[name='filter.v.price.lte']")?.value;
            if (priceMin || priceMax) {
              activeFilters_VIL.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
            }
            console.log("activeFilters_VIL>>>>>>>>>>",activeFilters_VIL);
          }
          let f_appliedValue = activeFilters_VIL.length > 0 ? activeFilters_VIL.join("|") : "NA";

          
          const productCards = Array.from(document.querySelectorAll(".product-card-event"));
          if (!productCards.length) return;

          window.dataLayer = window.dataLayer || [];

          const seenCards = new Set(); // to avoid duplicate events per card

          const buildItemFromCard = (card) => {
            return {
              item_id: card.getAttribute('data-item-id'),
              item_name: card.getAttribute('data-item-name') || 'Unknown Product',
              coupon: 'NA',
              discount: parseFloat(card.getAttribute('data-item-discount')) || 0,
              index: card.getAttribute('data-item-index') || 1,
              item_brand: 'The White Willow',
              item_category: card.getAttribute('data-item-category') || 'Sleep',
              item_category2: card.getAttribute('data-item-category2') || 'Pillow',
              item_category3: card.getAttribute('data-item-category3') || 'NA',
              item_category4: card.getAttribute('data-item-category4') || 'NA',
              item_category5: card.getAttribute('data-item-category5') || 'NA',
              item_list_id: card.getAttribute('data-item-list-id') || 'collection_page',
              item_list_name:
                card.getAttribute('data-item-list-name') ||
                card.closest('.shopify-section')?.querySelector('.inline-richtext')?.innerText ||
                'NA',
              item_variant: card.getAttribute('data-item-variant') || 'NA',
              price: parseFloat(card.getAttribute('data-item-price')) || 0,
              quantity: 1,
              item_size: card.getAttribute('data-size') || 'NA',
              item_dimensions: card.getAttribute('data-item-dimensions') || 'NA',
              filter_applied: f_appliedValue || 'NA',
              sort_applied: s_appliedValue || 'NA',
              shopify_sku_id: card.getAttribute('data-item-sku') || 'NA'
            };
          };

          // IntersectionObserver to detect when cards enter viewport
          const observer = new IntersectionObserver(
            (entries) => {
              const visibleItems = [];

              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const card = entry.target;
                  const cardId = card.getAttribute('data-item-id');

                  // Avoid firing multiple times for the same card
                  if (!seenCards.has(cardId)) {
                    seenCards.add(cardId);
                    visibleItems.push(buildItemFromCard(card));
                  }
                }
              });

              if (visibleItems.length) {
                // Push GA4 event only for newly visible items
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  event: "view_item_list_ce",
                  page_type: getPageType(),
                  platform: getPlatform(),
                  user_id_event: getUserId(),
                  user_status: getUserType(),
                  ecommerce: { items: visibleItems },
                });

                console.log("GA4 view_item_list_ce fired →", visibleItems);
              }
            },
            {
              threshold: 0.5, // 50% of card in viewport; tweak as needed
            }
          );

          // Observe all cards
          productCards.forEach((card) => observer.observe(card));


          if (isReset && resetURL) {
            setTimeout(() => (window.location.href = resetURL), 150);
          }
          },1500);
        } catch (err) {
          // console.warn("⚠️ GA4 sort_filter_applied error:", err);
        }
        
      // });
    }



  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/* ------------------------- Price Range and Remove ------------------------- */
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;

    facetLink.setAttribute('role', 'button');

    // Bind using facetLink so we always detect reset clicks
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  // Helper: get visible label/text for a given input (prefers human label with count)
  _getInputLabelText(input) {
    try {
      const label = input.closest('label');
      // often there is a visible span containing "In stock (19)"
      const visibleSpan = label?.querySelector('span[aria-hidden="true"], span:not(.visually-hidden)');
      if (visibleSpan && visibleSpan.innerText.trim()) return visibleSpan.innerText.trim();

      // fallback to full label text (may include visually-hidden text too)
      if (label && label.innerText.trim()) return label.innerText.trim();

      // fallback to input.value (numeric code)
      if (input.value) return input.value.trim();

      return 'Unknown Value';
    } catch (e) {
      return input.value || 'Unknown Value';
    }
  }

  // Helper: try to get the group/section name for a given input by walking up to the nearest details/parent container
  _getGroupLabelForInput(input) {
    try {
      // Try: nearest details element (common theme structure)
      let details = input.closest('details, [id^="Details-"], [id^="Facet-"], .parent-display, .facets__display, .parent-wrap');
      if (details) {
        // summary text is usually the group header
        const summary =
          details.querySelector('summary .facets__summary span') ||
          details.querySelector('summary .facets__summary') ||
          details.querySelector('summary') ||
          details.querySelector('.facets__header .facets__selected') ||
          details.querySelector('.facets__header');

        if (summary && summary.innerText.trim()) return summary.innerText.trim();
      }

      // fallback: look for nearest fieldset legend
      const fieldset = input.closest('fieldset');
      const legend = fieldset?.querySelector('legend');
      if (legend && legend.innerText.trim()) return legend.innerText.trim();

      // fallback: nearest parent list/container label
      const parent = input.closest('.parent-display, .facets__display, .list-menu__item, .facets-wrap');
      const alt = parent?.querySelector('.facets__selected, .facet-checkbox__text, legend, .facets__header, .facets__summary');
      if (alt && alt.innerText.trim()) return alt.innerText.trim();

      // last fallback
      return input.name?.trim() || 'Unknown Group';
    } catch (e) {
      return input.name || 'Unknown Group';
    }
  }

  closeFilter(event) {
    // Prevent navigation and default behaviour for tracking first
    if (event && event.preventDefault) event.preventDefault();

    // This element is specifically the reset control, so treat it as reset
    const isReset = true;

    // Build page and section meta
    const sectionName = document.querySelector('.collection-hero__title')?.innerText?.trim() || 'NA';
    const pageType = window.location.pathname.includes('/collections/')
      ? 'collection_page'
      : window.location.pathname.includes('/products/')
      ? 'product_page'
      : 'home';

    // // Collect all active filters BEFORE the reset action is actually applied
    // const activeFilters = [];

    // // 1) Checkbox filters (reads human label text e.g. "In stock (19)")
    // document.querySelectorAll('.js-filter input:checked, .facets__display input:checked, input[name^="filter"] :checked').forEach?.((input) => {
    //   // ensure we have the input element (some selectors may return parent nodes)
    //   if (!input || input.tagName?.toLowerCase() !== 'input') return;
    //   const groupLabel = this._getGroupLabelForInput(input);
    //   const valueLabel = this._getInputLabelText(input);
    //   activeFilters.push(`${groupLabel}-${valueLabel}`);
    // });

    // // Alternate checkbox selection (catch inputs that may not be under .js-filter)
    // document.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
    //   // skip ones already captured
    //   const already = activeFilters.find((f) => f.includes(input.value) || f.includes(input.id));
    //   if (already) return;
    //   const groupLabel = this._getGroupLabelForInput(input);
    //   const valueLabel = this._getInputLabelText(input);
    //   activeFilters.push(`${groupLabel}-${valueLabel}`);
    // });

    // // 2) Price range
    // const priceMin = document.querySelector('input[name="filter.v.price.gte"]')?.value;
    // const priceMax = document.querySelector('input[name="filter.v.price.lte"]')?.value;
    // if ((priceMin && priceMin !== '') || (priceMax && priceMax !== '')) {
    //   const minVal = priceMin && priceMin !== '' ? priceMin : 'NA';
    //   const maxVal = priceMax && priceMax !== '' ? priceMax : 'NA';
    //   activeFilters.push(`Price-${minVal}-${maxVal}`);
    // }

    // // 3) Sort
    // const sortSelect = document.querySelector('.facet-filters__sort, select[name="sort_by"], select.facet-filters__sort');
    // if (sortSelect) {
    //   const selected = sortSelect.options?.[sortSelect.selectedIndex]?.innerText?.trim();
    //   if (selected) activeFilters.push(`Sort-${selected}`);
    // }

    // // 4) Platform / other single-choice radio filters
    // const radioChecked = document.querySelector('input[type="radio"]:checked');
    // if (radioChecked) {
    //   const group = this._getGroupLabelForInput(radioChecked);
    //   const val = this._getInputLabelText(radioChecked);
    //   activeFilters.push(`${group}-${val}`);
    // }

    // // Prepare appliedValue string: if there are filters, join with pipe and add final pipe as required
    // const appliedValue = activeFilters.length > 0 ? activeFilters.join('|') + '|' : 'NA';

    // CTA text for this control is reset
    const ctaText = 'reset';

    // user info
    const userId = window.Shopify?.customer?.id || 'NA';
    const userStatus = userId !== 'NA' ? 'logged_in' : 'guest';

    // Push event (we push BEFORE we actually remove filters so we capture the pre-reset state)
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: 'sort_filter_applied',
    //   page_type: pageType,
    //   section_name: sectionName,
    //   applied_value: appliedValue,
    //   cta_text: ctaText,
    //   link_path: window.location.href || 'NA',
    //   user_id_event: userId,
    //   user_status: userStatus
    // });

  let activeFilters_VIL = [];
  let s_appliedValue = "NA";
  document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
      let groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
      let labelText = input.value;
      activeFilters_VIL.push(`${groupLabel}-${labelText}`);
  });
  let sortSelect = document.querySelector(".facet-filters__sort");
  if (sortSelect) {
      let selectedSort = sortSelect.options[sortSelect.selectedIndex].innerText.trim();
      s_appliedValue = `${selectedSort}`;
  }
  let priceMin = document.querySelector("input[name='filter.v.price.gte']")?.value;
  let priceMax = document.querySelector("input[name='filter.v.price.lte']")?.value;
  if (priceMin || priceMax) {
      activeFilters_VIL.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
  }

  if(window.outerWidth <= 767){
    activeFilters_VIL = [];
    s_appliedValue = "NA";
    document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
      console.log("input>>>>>>>",input);
      let groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
      let labelText = input.value;
      activeFilters_VIL.push(`${groupLabel}-${labelText}`);
    });
    let sortSelectM = document.querySelector(".mobile-facets__main .mobile-facets__sort select");
    if (sortSelectM) {
      let selectedSortM = sortSelectM.options[sortSelectM.selectedIndex].innerHTML.trim();
      s_appliedValue = `${selectedSortM}`;
    }
    let priceMin = document.querySelector(".mobile-facets__main input[name='filter.v.price.gte']")?.value;
    let priceMax = document.querySelector(".mobile-facets__main input[name='filter.v.price.lte']")?.value;
    if (priceMin || priceMax) {
      activeFilters_VIL.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
    }
    console.log("activeFilters_VIL>>>>>>>>>>",activeFilters_VIL);
  }
  let f_appliedValue = activeFilters_VIL.length > 0 ? activeFilters_VIL.join("|") : "NA";

    
  const productCards = Array.from(document.querySelectorAll(".product-card-event"));
  if (!productCards.length) return;

  window.dataLayer = window.dataLayer || [];

  const seenCards = new Set(); // to avoid duplicate events per card

  const buildItemFromCard = (card) => {
    return {
      item_id: card.getAttribute('data-item-id'),
      item_name: card.getAttribute('data-item-name') || 'Unknown Product',
      coupon: 'NA',
      discount: parseFloat(card.getAttribute('data-item-discount')) || 0,
      index: card.getAttribute('data-item-index') || 1,
      item_brand: 'The White Willow',
      item_category: card.getAttribute('data-item-category') || 'Sleep',
      item_category2: card.getAttribute('data-item-category2') || 'Pillow',
      item_category3: card.getAttribute('data-item-category3') || 'NA',
      item_category4: card.getAttribute('data-item-category4') || 'NA',
      item_category5: card.getAttribute('data-item-category5') || 'NA',
      item_list_id: card.getAttribute('data-item-list-id') || 'collection_page',
      item_list_name:
        card.getAttribute('data-item-list-name') ||
        card.closest('.shopify-section')?.querySelector('.inline-richtext')?.innerText ||
        'NA',
      item_variant: card.getAttribute('data-item-variant') || 'NA',
      price: parseFloat(card.getAttribute('data-item-price')) || 0,
      quantity: 1,
      item_size: card.getAttribute('data-size') || 'NA',
      item_dimensions: card.getAttribute('data-item-dimensions') || 'NA',
      filter_applied: f_appliedValue || 'NA',
      sort_applied: s_appliedValue || 'NA',
      shopify_sku_id: card.getAttribute('data-item-sku') || 'NA'
    };
  };

  // IntersectionObserver to detect when cards enter viewport
  const observer = new IntersectionObserver(
    (entries) => {
      const visibleItems = [];

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const cardId = card.getAttribute('data-item-id');

          // Avoid firing multiple times for the same card
          if (!seenCards.has(cardId)) {
            seenCards.add(cardId);
            visibleItems.push(buildItemFromCard(card));
          }
        }
      });

      if (visibleItems.length) {
        // Push GA4 event only for newly visible items
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_item_list_ce",
          page_type: getPageType(),
          platform: getPlatform(),
          user_id_event: getUserId(),
          user_status: getUserType(),
          ecommerce: { items: visibleItems },
        });

        console.log("GA4 view_item_list_ce fired →", visibleItems);
      }
    },
    {
      threshold: 0.5, // 50% of card in viewport; tweak as needed
    }
  );

  // Observe all cards
  productCards.forEach((card) => observer.observe(card));


    // Continue with original behavior (call the form's handler to actually remove the filter)
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') {
      // call with the original event so the theme removes the filter as expected
      form.onActiveFilterClick(event);
    } else {
      // fallback: follow the anchor href (this will navigate to the reset url)
      const link = this.querySelector('a');
      if (link && link.href) {
        window.location.href = link.href;
      }
    }
  }
}

customElements.define('facet-remove', FacetRemove);



